// @flow
import display from './display';
import overlay from './overlay';
import searchParams from './searchParams';
import system from './system';
import abacus from './abacus';
import expandedGroups from './expandedGroups';
import pinnedProperty from './pinnedProperty';
import viewport from './viewport';
import topBanners from './topBanners';
import typeaheadSuggestion from './typeaheadSuggestion';
import flexDates from './flexDates';
import redirect from './redirect';
import dateRangePicker from './dateRangePicker';
import recentlyViewed from './recentlyViewed';
import modals from './modals';
import map from './map';
import header from './header';
import user from './user';
import {toasterReducers} from '@homeaway/react-toaster';
import {tripboardButtonReducer} from '@homeaway/react-trip-board-button';

import type {Store as ReduxStore} from 'redux';

import type {Action, Dispatch} from '../actions/types';
import type {State as AbacusState} from './abacus';
import type {State as DisplayState} from './display';
import type {State as OverlayState} from './overlay';
import type {State as SearchParamsState} from './searchParams';
import type {State as ExpandedGroupsState} from './expandedGroups';
import type {State as PinnedPropertyState} from './pinnedProperty';
import type {State as SystemState} from './system';
import type {State as TypeaheadSuggestionState} from './typeaheadSuggestion';
import type {State as ViewportState} from './viewport';
import type {State as TopBannersState} from './topBanners';
import type {State as RedirectState} from './redirect';
import type {State as FlexDatesState} from './flexDates';
import type {State as DateRangePickerState} from './dateRangePicker';
import type {State as RecentlyViewedState} from './recentlyViewed';
import type {State as ModalsState} from './modals';
import type {State as MapState} from './map';
import type {State as HeaderState} from './header';
import type {State as UserState} from './user';

type RouterState = {router: any};

type _State = {
    display: DisplayState,
    overlay: OverlayState,
    searchParams: SearchParamsState,
    system: SystemState,
    abacus: AbacusState,
    expandedGroups: ExpandedGroupsState,
    viewport: ViewportState,
    pinnedProperty: PinnedPropertyState,
    topBanners: TopBannersState,
    redirect: RedirectState,
    flexDates: FlexDatesState,
    dateRangePicker: DateRangePickerState,
    recentlyViewed: RecentlyViewedState,
    modals: ModalsState,
    map: MapState,
    typeaheadSuggestion: TypeaheadSuggestionState,
    header: HeaderState,
    user: UserState
};

// need to export State with RouterState since Router is not reduced by us
export type State = _State & RouterState;
export type Store = ReduxStore<State, Action, Dispatch>;

const reducers = {
    display,
    overlay,
    searchParams,
    system,
    typeaheadSuggestion,
    flexDates,
    abacus,
    expandedGroups,
    viewport,
    pinnedProperty,
    topBanners,
    redirect,
    dateRangePicker,
    recentlyViewed,
    tripboardButton: tripboardButtonReducer,
    toaster: toasterReducers,
    modals,
    map,
    header,
    user
};

export default reducers;
